<template>
  <div class="productList">
    <info
      title="产品展示"
      refAnimal="productList"
      content1="控制器与触摸屏类、变送器与传感器类、开关类等..."
    />

    <div class="container animated fadeInUpBig">
      <div class="btnContent">
        <div class="btnBox1" v-for="(item, index) in menuBtnList">
          <el-button
            type="text"
            :class="{ isShow: selectedBtn === index }"
            @click="queryProList(item, index)"
          >
            {{ item.name }}
          </el-button>
          <div v-if="index + 1 !== menuBtnList.length" style="width: 1px;margin: 0 10px;height: 15px; background: #000;"></div>
        </div>
      </div>

      <div class="btnContent">
        <div class="btnBox2" v-for="(item, index) in menuBtnChildrenList">
          <el-button
            type="text"
            :class="{ isShow: selectedChildrenBtn === index }"
            @click="queryChildrenProList(item, index)"
          >
            {{ item.name }}
          </el-button>
          <div v-if="index + 1 !== menuBtnChildrenList.length" style="width: 1px;margin: 0 10px;height: 15px; background: #000;"></div>
        </div>
      </div>
    </div>

    <div class="display-list">
      <div class="display-item animated fadeInUpBig" v-for="item in dataList" @click="goDetail(item)">
        <div class="imgBox">
          <img :src="baseUrl + item.img" alt="">
        </div>
        <p>{{ item.name }}</p>
      </div>
    </div>

    <p class="empty-class" v-if="dataList && dataList.length <= 0" :image-size="200">暂无数据 ～～～</p>

    <el-button class="animated fadeInUpBig" type="primary" round @click="$router.push({path: '/productDisplay'})">更多<i class="el-icon-right el-icon--right"></i></el-button>
  </div>
</template>

<script>
import info from '@/components/index/Info'
import { menuList, proList } from "@/api/product";

export default {
  name: "productList",

  components: { info },

  data() {
    const baseUrl = process.env.VUE_APP_BASE_API

    return {
      baseUrl: baseUrl,
      menuList: [],
      menuBtnList: [],
      menuBtnChildrenList: [],
      selectedBtn: 0,
      selectedChildrenBtn: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 9,
        ishome: '1',
        proOrSol: '0'
      },
      dataList: [],
    }
  },

  mounted() {

  },

  created() {
    this.getMenuList()
  },

  methods: {
    queryProList(item, index) {
      this.selectedChildrenBtn = 0
      this.selectedBtn = index || index === 0 ? index : this.selectedBtn
      this.menuBtnChildrenList = this.menuList.filter(val => {
        return val.pid === item.id
      })

      if (this.menuBtnChildrenList.length > 0) {
        this.queryChildrenProList(this.menuBtnChildrenList[0])
      } else {
        this.queryParams.type = item.name || this.queryParams.type
        proList(this.queryParams).then(res => {
          console.log('产品列表', res)
          this.dataList = res.rows
          this.total = res.total
        })
      }

      // this.queryParams.type = item.name || this.queryParams.type
      // console.log('产品列表参数', this.queryParams)
      // proList(this.queryParams).then(res => {
      //   console.log('产品列表', res)
      //   this.dataList = res.rows
      //   this.total = res.total
      // })
    },

    queryChildrenProList(item, index) {
      this.selectedChildrenBtn = index || index === 0 ? index : this.selectedChildrenBtn
      this.queryParams.type = item.name || this.queryParams.type
      console.log('产品列表参数', this.queryParams)
      proList(this.queryParams).then(res => {
        console.log('产品列表', res)
        this.dataList = res.rows
        this.total = res.total
      })
    },

    getMenuList() {
      menuList().then(res => {
        console.log('menuList', res)
        this.menuList = res.rows
        this.menuBtnList = res.rows.filter(val => {
          return val.pid === '0'
        })
        this.menuBtnChildrenList = res.rows.filter(val => {
          return val.pid === this.menuBtnList[0].id
        })
        this.queryChildrenProList(this.menuBtnChildrenList[0])
      })
    },

    goDetail(item) {
      console.log('item', item)
      this.$router.push({
        path: '/productDetail',
        query: {
          obj: JSON.stringify(item)
        }
      })
    },
  }
}
</script>

<style lang='less' scoped>
@media screen and (min-width: 768px) {
  .display-list {
    max-width: 1170px;
  }
  .display-item {
    div {
      width: 300px;
      height: 242px;
      overflow: hidden;
    }

    p {
      width: 300px;
    }
  }
}
@media screen and (max-width: 768px) {
  .display-list {
    width: 100%;
  }
  .display-item {
    div {
      width: 170px;
      height: 140px;
      overflow: hidden;
    }
    p {
      width: 170px;
    }
  }
}

.productList {
  display: flex;
  flex-direction: column;
  align-items: center;

  .empty-class {
    color: #e4e4e4;
  }
}

.container {
  width: 100%;

  .btnContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;

    .isShow {
      // background-color: rgb(10, 132, 202);
      color: red !important;
    }

    .btnBox1 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 18px;
      }
    }

    .btnBox2 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 15px;
      }
    }

    .el-button {
      padding: 10px 0;
      color: black;

      &:hover {
        color: red;
      }
    }
  }
}

.display-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px 5px;
  box-sizing: border-box;

  .display-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 6px 12px 6px;

    .imgBox {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #e4e7ed;
      box-sizing: border-box;

      img {
        transition: all .5s;
        width: 70%;
        // height: 100%;

        &:hover {
          transform: scale(1.2);
        }
      }
    }

    p {
      margin: 0;
      padding: 5px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
      text-align: center;
    }

    &:hover {
      cursor: pointer;

      .imgBox {
        border-bottom: none;
        border-color: #3a8ee6;
      }

      p {
        background: #3a8ee6;
        color: #fff;
      }
    }
  }
}
</style>

<style lang="less">
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both
}

@-webkit-keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0)
  }
}

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    -ms-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0)
  }
}

  .fadeInUpBig {
    -webkit-animation-name: fadeInUpBig;
    animation-name: fadeInUpBig
  }
</style>
